/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import './ClaimListTile.css';
import { Grid } from '@mui/material';
import { fonts, themes } from '../../themes/themes';
import { Box } from '@mui/system';
import { useAppSelector } from '../../../infra/hooks';
import { useTranslation } from 'react-i18next';
import { DateField } from '../../../components';
import { baseDateFormatting } from '../../helper';
interface contentTileType {
  claimName: string;
  amount: any;
  travelDate?: string;
  status?: any;
  onClickView?: any;
}
const ClaimListTile: React.FC<contentTileType> = ({
  claimName,
  travelDate,
  amount,
  status,
  onClickView,
}) => {
  const { t } = useTranslation();
  const trans = t;
  const currency = useAppSelector((state) => state.authSlice.currency);
  return (
    <Grid container className="claimApplied-container">
      <Grid item xs={10}>
        <Grid container>
          <Grid
            item
            xs={12}
            style={{
              fontSize: fonts.title,
              fontFamily: fonts.fontFamily,
              color: themes.blackDefault,
              fontWeight: 'bold',
              textTransform: 'capitalize',
            }}
          >
            {claimName}
          </Grid>

          <Grid
            item
            xs={12}
            style={{
              fontSize: fonts.subtitle,
              fontFamily: fonts.fontFamily,
              color: themes.defaultIcon,
              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: 'flex-start',
              letterSpacing: '0.01px',
              marginTop: '10px',
              textTransform: 'capitalize',
            }}
          >
            {trans('Claim Date')} :{' '}
            <span style={{ color: themes.blackDefault }} className="mx-1">
              {travelDate ? (
                <DateField value={travelDate} format={baseDateFormatting} />
              ) : null}
            </span>{' '}
          </Grid>
          <Grid
            item
            xs={12}
            style={{
              fontSize: fonts.subtitle,
              fontFamily: fonts.fontFamily,
              color: themes.defaultIcon,
              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: 'flex-start',
              textTransform: 'capitalize',
              letterSpacing: '0.01px',
              marginTop: '2px',
            }}
          >
            {trans('Amount')} :
            <span style={{ color: themes.blackDefault }} className="mx-1">
              {' '}
              {currency} {amount}
            </span>{' '}
          </Grid>

          <Grid
            item
            xs={12}
            style={{
              fontSize: fonts.subtitle,
              fontFamily: fonts.fontFamily,
              color: themes.defaultIcon,
              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: 'flex-start',
              letterSpacing: '0.01px',
              marginTop: '2px',
              textTransform: 'capitalize',
            }}
          >
            {trans('Status')} :{' '}
            {status == 0 ? (
              <span style={{ color: themes.defaultMisc }} className="mx-1">
                {trans('Waiting for Approval')}
              </span>
            ) : status == 2 ? (
              <span style={{ color: themes.defaultError }} className="mx-1">
                {trans('Rejected')}
              </span>
            ) : (
              <span style={{ color: themes.defaultSuccess }} className="mx-1">
                {trans('Approved')}
              </span>
            )}
          </Grid>
        </Grid>
      </Grid>
      <Grid
        item
        xs={2}
        style={{
          display: 'flex',
          alignItems: 'flex-end',
          justifyContent: 'flex-end',
          flexDirection: 'row',
        }}
      >
        <Box className="icon-box_claim" onClick={onClickView}>
          {' '}
          <i className="las la-eye" color={themes.primaryMain} />{' '}
        </Box>
      </Grid>
    </Grid>
  );
};

export default ClaimListTile;
